export default __webpack_public_path__ + "static/media/Wave-1.0bcd9fde.webp";